import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Icon, tokens } from '@hotjar/hotsauce';
import { SPACING } from '../constants';
import { StickerRelevantActionButton } from './StickerRelevantActionButton';

const StickerCreateHighlightBtn = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <StickerRelevantActionButton
      tooltip={t('highlights:recordings.create-tooltip')}
      onClick={onClick}
      spacing={SPACING}
    >
      <Icon
        css={css`
          color: ${tokens.color.text_default};
        `}
        icon="lightbulb"
        size="m"
      />
    </StickerRelevantActionButton>
  );
};

StickerCreateHighlightBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const StickerCreateHighlightButton = memo(StickerCreateHighlightBtn);
